<template>
  <tbody v-if="historyRecord">
    <tr>
      <td>
        <div class="is-flex flex-direction--column padding-left--small">
            <span class="is-flex">
              {{
                new Intl.DateTimeFormat('en', {
                  year:'numeric',
                  month:'2-digit',
                  day:'2-digit',
                })
                .format(new Date(historyRecord.lastUpdateDate))
              }}
            </span>
        </div>
      </td>
      <td v-if="fieldEnabled('FIRST_NAME')
            || fieldEnabled('LAST_NAME')">
        <div>
          {{ personHistoryDisplayName }}
        </div>
      </td>
      <td style="text-align: right !important">
        <router-link
          :to="{
            name: 'PidHistoryRecordDetails',
            query: {
              recordId: historyRecord.lastTranSerialNumber,
              retired: isRetired,
            }
          }">
          <font-awesome-icon
            :icon="['far', 'angle-double-right']"
            size="2x"
            title="View Details"
          />
        </router-link>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDoubleRight,
} from '@fortawesome/pro-regular-svg-icons';
import { mapGetters } from 'vuex';
import FieldLabels from '@/mixins/FieldLabels';

library.add(
  faAngleDoubleRight,
);

export default {
  mixins: [
    FieldLabels,
  ],
  props: {
    historyRecord: {
      type: Object,
      required: true,
    },
    isRetired: {
      type: Boolean,
      default: false,
    },
    person: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    ...mapGetters('fieldLabelsModule', [
      'getFieldEnabledForPersonType',
    ]),
    personHistoryDisplayName() {
      if (this.fieldEnabled('FIRST_NAME')
            && this.fieldEnabled('LAST_NAME')) {
        return `${this.historyRecord.lastName}, ${this.historyRecord.firstName}`;
      }
      if (this.fieldEnabled('FIRST_NAME')) {
        return this.historyRecord.firstName;
      }
      return this.historyRecord.lastName;
    },
  },
  methods: {
    fieldEnabled(code) {
      return this.getFieldEnabledForPersonType(code, 'ASSIGN', this.person.personType);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
